"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadowBuilder = exports.boxShadows = exports.depths = exports.mediaQueryBetween = exports.mediaQuery = exports.breakpoints = exports.scaffolding = exports.font = exports.fontWeights = exports.chartColorPallette = exports.colors = void 0;
/* tslint:disable */
exports.colors = {
    green0: '#EFF8ED',
    green1: '#5CB335',
    green2: '#488929',
    green3: '#33621D',
    green4: '#7BD293',
    lightGreen1: '#ECF3EA',
    lightGreen2: '#DAE7D5',
    lightGreen3: '#B7D0AC',
    red1: '#EE3A36',
    red2: '#B81430',
    red3: '#8A0F24',
    red4: '#D78585',
    pink1: '#EDDCDC',
    pink2: '#E8C6C5',
    pink3: '#DC9997',
    amber: '#F9A12A',
    amber2: '#D98615',
    amber3: '#A1610A',
    orange: '#D8A14C',
    grey1: '#F7F7F7',
    grey2: '#E6E6E6',
    grey3: '#CCCCCC',
    grey4: '#999999',
    grey5: '#737373',
    grey6: '#4D4D4D',
    grey7: '#333333',
    grey8: '#1A1A1A',
    grey9: '#99A5AF',
    greyBg: '#F2F2F2',
    white: '#ffffff',
    black: '#000000',
    blue: '#6BABC7',
    blue1: '#77B4E1',
    transparent: 'rgba(0,0,0,0)',
    lightbox: 'rgba(50, 50, 50, 0.6)',
    purple0: '#B67AC5',
    chartDarkBlue: '#032E45',
    chartLightBlue: '#77B0BE',
    chartBrightTeal: '#0696A6',
    chartMediumGrey: '#ADAFB2',
    chartOrange: '#FF600F',
    chartDarkGreen: '#15723B',
    chartDarkTeal: '#006176',
    chartLightOrange: '#FF910F',
    chartMediumGreen: '#008F0A',
    chartDarkGrey: '#595959',
    green50: '#EFF8ED',
    green100: '#DAF1D0',
    green200: '#B8E4A5',
    green300: '#93D676',
    green400: '#75CA4E',
    green500: '#5CB335',
    green600: '#488929',
    green700: '#33621D',
    green800: '#254715',
    green900: '#1F3B12',
    grey50: '#F9FAFB',
    grey100: '#F2F2F2',
    grey200: '#E6E6E6',
    grey300: '#CCCCCC',
    grey400: '#999999',
    grey500: '#737373',
    grey600: '#4D4D4D',
    grey700: '#333333',
    grey800: '#1A1A1A',
    grey900: '#0D0D0D',
    red50: '#FEF2F2',
    red100: '#FEE2E2',
    red200: '#FECACA',
    red300: '#FCA5A5',
    red400: '#F87171',
    red500: '#EF4444',
    red600: '#DC2626',
    red700: '#B91C1C',
    red800: '#991B1B',
    red900: '#7F1D1D',
    amber50: '#FFFBEB',
    amber100: '#FEF3C7',
    amber200: '#FDE68A',
    amber300: '#FCD34D',
    amber400: '#FBBF24',
    amber500: '#F59E0B',
    amber600: '#D97706',
    amber700: '#B45309',
    amber800: '#92400E',
    amber900: '#78350F',
    lime50: '#F7FEE7',
    lime100: '#ECFCCB',
    lime200: '#D9F99D',
    lime300: '#BEF264',
    lime400: '#A3E635',
    lime500: '#84CC16',
    lime600: '#65A30D',
    lime700: '#4D7C0F',
    lime800: '#3F6212',
    lime900: '#365314',
    emerald50: '#ECFDF5',
    emerald100: '#D1FAE5',
    emerald200: '#A7F3D0',
    emerald300: '#6EE7B7',
    emerald400: '#34D399',
    emerald500: '#10B981',
    emerald600: '#059669',
    emerald700: '#047857',
    emerald800: '#065F46',
    emerald900: '#064E3B',
    cyan50: '#ECFEFF',
    cyan100: '#CFFAFE',
    cyan200: '#A5F3FC',
    cyan300: '#67E8F9',
    cyan400: '#22D3EE',
    cyan500: '#06B6D4',
    cyan600: '#0891B2',
    cyan700: '#0E7490',
    cyan800: '#155E75',
    cyan900: '#164E63',
    sky50: '#F0F9FF',
    sky100: '#E0F2FE',
    sky200: '#BAE6FD',
    sky300: '#7DD3FC',
    sky400: '#38BDF8',
    sky500: '#0EA5E9',
    sky600: '#0284C7',
    sky700: '#0369A1',
    sky800: '#075985',
    sky900: '#0C4A6E',
    blue50: '#EFF6FF',
    blue100: '#DBEAFE',
    blue200: '#BFDBFE',
    blue300: '#93C5FD',
    blue400: '#60A5FA',
    blue500: '#3B82F6',
    blue600: '#2563EB',
    blue700: '#1D4ED8',
    blue800: '#1E40AF',
    blue900: '#1E3A8A',
    violet50: '#F5F3FF',
    violet100: '#EDE9FE',
    violet200: '#DDD6FE',
    violet300: '#C4B5FD',
    violet400: '#A78BFA',
    violet500: '#8B5CF6',
    violet600: '#7C3AED',
    violet700: '#6D28D9',
    violet800: '#5B21B6',
    violet900: '#4C1D95',
    rose50: '#FDF2F8',
    rose100: '#FCE7F3',
    rose200: '#FBCFE8',
    rose300: '#F9A8D4',
    rose400: '#F472B6',
    rose500: '#EC4899',
    rose600: '#DB2777',
    rose700: '#BE185D',
    rose800: '#9D174D',
    rose900: '#831843',
};
exports.chartColorPallette = [
    exports.colors.chartDarkBlue,
    exports.colors.chartLightBlue,
    exports.colors.chartBrightTeal,
    exports.colors.chartMediumGrey,
    exports.colors.chartOrange,
    exports.colors.chartDarkGreen,
    exports.colors.chartDarkTeal,
    exports.colors.chartLightOrange,
    exports.colors.chartMediumGreen,
    exports.colors.chartDarkGrey,
];
exports.fontWeights = {
    bold: 700,
    medium: 500,
    regular: 400,
    light: 300,
};
exports.font = {
    color: exports.colors.grey700,
    fontFamily: "'Roboto', Helvetica, Arial, sans-serif",
    fontSize: '16px',
    fontWeight: exports.fontWeights.regular,
    letterSpacing: 'normal',
    textAlign: 'left',
    WebkitFontSmoothing: 'antialiased',
    lineHeight: '20px',
};
exports.scaffolding = {
    xxs: '2px',
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '64px',
};
exports.breakpoints = {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1600px',
    dropdown: '1024px',
};
exports.mediaQuery = function (breakpoint) {
    return "@media (min-width: " + breakpoint + ")";
};
exports.mediaQueryBetween = function (breakpointMin, breakpointMax) { return "@media (min-width: " + breakpointMin + ") and (max-width: " + breakpointMax + ")"; };
exports.depths = {
    snack: 999,
    modal: 998,
    appBar: 997,
    monthPicker: 996,
};
exports.boxShadows = {
    1: '0 3px 10px 0 rgba(0,0,0,0.1)',
    2: '0 2px 10px 0 rgba(0,0,0,0.2)',
    3: '0 4px 24px 0 rgba(0,0,0,0.25)',
    4: '0 8px 10px 0 rgba(0,0,0,0.3)',
};
exports.shadowBuilder = function (level) {
    return exports.boxShadows[level];
};
/* tslint:enable */
//# sourceMappingURL=theme.js.map